﻿import { nanoid } from "nanoid";

export default class SuperFund {
    constructor() {
        this.Id = nanoid(6)
        this.FundName = null;
        this.FundNameLabel = null;
        this.FundNameOther = null;
        this.PolicyNumber = null;
        this.Benefits = null;
        this.BenefitsOther = null;
        this.ClaimLodged = null;
    }
}